import React from "react";

const DoubleInputSkeleton = () => {
  return (
    <div className="flex gap-3">
      <div className="h-12 w-full rounded-md bg-gray-300"></div>
      <div className="h-12 w-full rounded-md bg-gray-300"></div>
    </div>
  );
};

export default DoubleInputSkeleton;
